import type { RootState } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

export const defaultSNSList = (state: RootState) => state.defaultSNSList;
export const getDefaultSNSList = createSelector(defaultSNSList, (state) => state.data);
